import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74de3060"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-about-links" }
const _hoisted_2 = { class: "page-links" }
const _hoisted_3 = {
  key: 0,
  class: "social-links"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "sub-links" }

import Initiator from '@/components/Initiator.vue';
import { useHome } from '@/store/useHome';



export default /*#__PURE__*/_defineComponent({
  __name: 'MenuAboutLinks',
  emits: ['click'],
  setup(__props) {

const { home } = useHome();



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(home).hamburgerMenu.menuItems, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.title
        }, [
          _createVNode(_component_router_link, {
            to: '/content/' + item.slug,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.title), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", null, [
      (_unref(home).hamburgerMenu.facebookUrl || _unref(home).hamburgerMenu.instagramUrl)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
            (_unref(home).hamburgerMenu.facebookUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "social-link",
                  href: _unref(home).hamburgerMenu.facebookUrl,
                  target: "_blank",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click', $event)))
                }, [
                  _createVNode(_component_Icon, { name: "facebook" })
                ], 8, _hoisted_4))
              : _createCommentVNode("", true),
            (_unref(home).hamburgerMenu.instagramUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "social-link",
                  href: _unref(home).hamburgerMenu.instagramUrl,
                  target: "_blank",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('click', $event)))
                }, [
                  _createVNode(_component_Icon, { name: "instagram" })
                ], 8, _hoisted_5))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(Initiator, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('click', $event))),
        class: "initiator-link",
        dark: "",
        smallText: ""
      }),
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", null, [
          (_unref(home).hamburgerMenu.privacyStatementPage)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('click', $event))),
                to: '/content/' + _unref(home).hamburgerMenu.privacyStatementPage.slug
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(home).hamburgerMenu.privacyStatementPage.title), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", null, [
          _createVNode(_component_router_link, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('click', $event))),
            to: "/sitemap"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Sitemap")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})